import { render, staticRenderFns } from "./mobile_not_support.vue?vue&type=template&id=1291b576&"
import script from "./mobile_not_support.vue?vue&type=script&lang=js&"
export * from "./mobile_not_support.vue?vue&type=script&lang=js&"
import style0 from "./mobile_not_support.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports